import { useCallback } from 'react'
import { DropdownItem } from '@/forms-legacy'
import { useRecurrenceDispatch } from '../../../providers/StateProvider'
import { parseRecurrenceWhen } from './utils/parseRecurrenceWhen.ts'
import { useCalendarConfig } from '../../../providers/CalendarConfigProvider'

export function useOnChange() {
  const dispatch = useRecurrenceDispatch()
  const calendarConfig = useCalendarConfig()

  return useCallback(
    (items: DropdownItem[]) => {
      if (items.length > 0) {
        const { id } = items[0]
        const recurrenceWhen = parseRecurrenceWhen(id)

        dispatch({
          type: 'recurrenceWhen:change',
          recurrenceWhen,
          calendarConfig,
        })
      }
    },
    [dispatch, calendarConfig],
  )
}
